export default "__VITE_ASSET__Br08XG4P__"